/** @format */

import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import OrdersContentColumn from "../content/OrdersContentColumn";
import SectionItem from "../../orders-new/section-item";
import OrdersSectionItemInfoColumn from "../../orders-new/section-item/components/OrdersSectionItemInfoColumn";
import OrdersDatePicker from "../date-picker-new";
import OrdersTransportTypeWrapper from "../transport-type-new/OrdersTransportTypeWrapper";
import OrdersLocationInfo from "../location-info";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddYourCity from "../add-your-city/AddYourCity";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomSelect from "../../custom/custom-select";
import CustomUploadFileMultiple from "../../orders-aviation/components/custom-upload/CustomUploadFileMultiple";
import OrdersMap from "../../orders-new/map/OrdersMap";
import OrdersSectionItemCreate from "../../orders-new/section-item/components/OrdersSectionItemCreate";
import AddIntermediatePoint from "../../orders-new/section-item/components/AddIntermediatePoint";
import CopyIcon from "../../shared/icons/CopyIcon";
import SimpleCategoryModal from "../add-new-category/SimpleCategoryModal";
import OrdersSectionItemPaymentExpeditor from "../../orders-new/section-item/components/OrdersSectionItemPaymentExpeditor";
import { useScreenSize } from "../../../hooks/useScreenSize";
import AccessDeniedModal from "../../shared/SubscriptionModal/AccessDeniedModal";
import { useOrderLimit } from "../../../hooks/useClientLimits";
import CustomInputWithUnits from "../../custom/custom-input-with-units/CustomInputWithUnits";
import { WEIGHT_UNITS } from "../../../mock";
import PalletIcon from "../../shared/icons/PalletIcon";

const OrdersCreateExpeditorView = ({
  setCountryFrom,
  setCityFrom,
  countries,
  countryFrom,
  citiesFrom,
  cityFrom,
  countryTo,
  setCountryTo,
  setCityTo,
  citiesTo,
  cityTo,
  pickUpDate,
  pickUpStartTime,
  pickUpEndTime,
  minPickDate,
  setPickUpDate,
  setPickUpStartTime,
  setPickUpEndTime,
  deliveryDate,
  deliveryStartTime,
  deliveryEndTime,
  minDeliveryDate,
  setDeliveryDate,
  setDeliveryStartTime,
  setDeliveryEndTime,
  types,
  setType,
  setTemperature,
  type,
  addressTo,
  setAddressTo,
  recipientUpdate,
  addressFrom,
  setAddressFrom,
  setRecipientUpdate,
  recipientName,
  setRecipientName,
  recipientPhone,
  setRecipientPhone,
  volume,
  setVolume,
  weight,
  setWeight,
  weightUnit,
  setWeightUnit,
  pallet,
  setPallet,
  categories,
  setCategories,
  category,
  setCategory,
  temperatures,
  temperature,
  loadingTypes,
  loadingType,
  setLoadingType,
  details,
  setDetails,
  insurance,
  queryInsurance,
  declaredPrice,
  calcInsurance,
  fileInvoice,
  setInvoiceFile,
  files,
  setFiles,
  distance,
  price,
  netPrice,
  algoPrice,
  setAlgoPrice,
  predictedPrice,
  setPredictedPrice,
  insurancePrice,
  createLoading,
  copyCount,
  setCopyCount,
  createOrder,
  orderCalculation,
  onResetPrice,
  saveDraft,
  updatePrice,
  onPriceChange,
  setIsСallСities,
  isCalculatePrice,
  isLoadingMap,
  routeData,
  routeStartCity,
  isTender,
  setCoordinatesFrom,
  setCoordinatesTo,
  coordinatesFrom,
  coordinatesTo,
  addressIdFrom,
  addressIdTo,
  setAddressIdFrom,
  setAddressIdTo,
  points,
  setPoints,
  senderName,
  setSenderName,
  setSenderPhone,
  setRouteDistance,
  setRouteDuration,
  isCopy = false,
  isEdit = false,
  isReadOnly = false,
  headTitle = "",
  currency,
  setCurrency,
  routeDistance,
  isOwnFleetExecutor,
  setIsOwnFleetExecutor,
  serverFiles = [],
  onDeleteServerFile,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const { isMobileView } = useScreenSize();
  const { orderLimit } = useOrderLimit();

  const [isOpenAddFrom, setIsOpenAddFrom] = useState(false);
  const [isOpenAddTo, setIsOpenAddTo] = useState(false);
  const [initialCityNameFrom, setInitialCityNameFrom] = useState("");
  const [initialCityNameTo, setInitialCityNameTo] = useState("");
  const [isCommentVisibleFrom, setIsCommentVisibleFrom] = useState(false);
  const [isCommentVisibleTo, setIsCommentVisibleTo] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [isDisplayModal, changeDisplayModal] = useState(false);

  const [errors, setErrors] = useState({});

  const handleCommentChange = (newValue) => {
    setDetails(newValue);
  };

  const handleTemperatureChange = (newValue) => {
    setTemperature(newValue);
  };

  const toggleCommentVisibilityFrom = () => {
    setIsCommentVisibleFrom(!isCommentVisibleFrom);
  };
  const toggleCommentVisibilityTo = () => {
    setIsCommentVisibleTo(!isCommentVisibleTo);
  };

  const handleAddCategoryClick = () => {
    setShowCategoryModal(true);
  };

  const handleCategoryAdded = (newCategory) => {
    setCategories([...categories, newCategory]);

    setCategory(newCategory);
    onResetPrice();

    setShowCategoryModal(false);
  };

  useEffect(() => {
    if (
      (user && user?.permissions?.includes("restricted_view")) ||
      (user && user?.permissions && !user?.permissions?.includes("order_create"))
    ) {
      changeDisplayModal(true);
    } else if (user && user?.role && !user.role?.isUnlimited && orderLimit !== null && orderLimit <= 0) {
      changeDisplayModal(true);
    }
  }, [user, orderLimit]);

  useEffect(() => {
    if (
      cityFrom &&
      countryFrom &&
      cityTo &&
      countryTo &&
      category &&
      type &&
      weight &&
      volume &&
      routeDistance
    ) {
      orderCalculation();
    } else {
      setAlgoPrice(0);
      setPredictedPrice({});
    }
  }, [
    cityFrom,
    countryFrom,
    cityTo,
    countryTo,
    category,
    type,
    weight,
    volume,
    routeDistance,
    pickUpDate,
    weightUnit,
  ]);

  const isValidateForm = useMemo(() => {
    let allow = true;
    if (algoPrice) {
      if (!pickUpDate || !pickUpStartTime || !pickUpEndTime || !countryFrom) {
        allow = false;
      } else if (!deliveryDate || !deliveryStartTime || !deliveryEndTime || !countryTo) {
        allow = false;
      } else if ((insurance && !declaredPrice) || !recipientName) {
        allow = false;
      }
    }

    if (insurance && !declaredPrice) {
      allow = false;
    }
    if (insurance && !fileInvoice?.name) {
      allow = false;
    }
    
    if (!pickUpDate || !pickUpStartTime || !pickUpEndTime || !countryFrom) {
      allow = false;
    }

    if (!deliveryDate || !deliveryStartTime || !deliveryEndTime || !countryTo) {
      allow = false;
    }

    if (!cityFrom || !cityTo || !weight || !type || !category || price < 0) {
      allow = false;
    }
    if (price && parseFloat(price) > 2000000000) {
      allow = false;
    }

    if (type?.value === "refrigerator" && !temperature) {
      allow = false;
    }

    if (!isOwnFleetExecutor) {
      allow = false;
    }
    if (!addressFrom || !addressIdFrom) {
      allow = false;
    }

    if (!addressTo || !addressIdTo) {
      allow = false;
    }

    if (weight && (weight.toString().length > 8 || parseFloat(weight) < 0)) {
      allow = false;
    }
    if (
      (volume && (volume.toString().length > 8 || parseFloat(volume) < 0)) ||
      (pallet && (pallet.toString().length > 8 || parseFloat(pallet) < 0))
    ) {
      allow = false;
    }

    if (!price || price <= 0) {
      allow = false;
    }
    if (
      points.some(
        (point) =>
          !point.country ||
          !point.city ||
          !point.address ||
          point.shippingDate === null ||
          !point.shippingDate ||
          point.shippingHourFrom === 0 ||
          point.shippingHourTo === 0 ||
          !point.shippingHourFrom ||
          !point.shippingHourTo ||
          !point.latLng ||
          !point.recipientName
      )
    ) {
      allow = false;
    }

    return allow;
  }, [
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    cityFrom,
    countryFrom,
    algoPrice,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    cityTo,
    countryTo,
    category,
    type,
    temperature,
    weight,
    volume,
    pallet,
    insurance,
    declaredPrice,
    fileInvoice,
    recipientName,
    price,
    points,
    isOwnFleetExecutor,
  ]);

  const submitFormData = () => {
    if (
      user &&
      (!user?.permissions?.includes("order_create") || (!user?.role?.isUnlimited && orderLimit <= 0))
    ) {
      changeDisplayModal(true);
      return;
    }

    if (createLoading) return;

    const newErrors = {};
    setErrors(null);
    if (!isValidateForm) {
      if (
        !pickUpDate ||
        !pickUpStartTime ||
        !pickUpEndTime ||
        !deliveryDate ||
        !deliveryStartTime ||
        !deliveryEndTime
      ) {
        !pickUpDate && (newErrors.pickUpDate = t("ordersCreate.validation.fillData"));
        !pickUpStartTime && (newErrors.pickUpStartTime = t("ordersCreate.validation.fillData"));
        !pickUpEndTime && (newErrors.pickUpEndTime = t("ordersCreate.validation.fillData"));
        !deliveryDate && (newErrors.deliveryDate = t("ordersCreate.validation.fillData"));
        !deliveryStartTime && (newErrors.deliveryStartTime = t("ordersCreate.validation.fillData"));
        !deliveryEndTime && (newErrors.deliveryEndTime = t("ordersCreate.validation.fillData"));
        toast.error(t("ordersCreate.validation.fillTimeError"));
      }
      // if (!details){
      //   toast.error('Необходимо заполнить поле "Описание груза"')
      // }
      if (!addressFrom) {
        !addressFrom && (newErrors.addressFrom = t("ordersCreate.validation.fillData"));
        toast.error(t("ordersCreate.validation.selectSenderError"));
      }
      if (!addressTo) {
        !addressTo && (newErrors.addressTo = t("ordersCreate.validation.fillData"));
        toast.error(t("ordersCreate.validation.selectRecipientError"));
      }
      if (!copyCount || +copyCount < 1) {
        toast.error(t("ordersCreate.validation.copyCountZeroError"));
      }
      if (insurance && !declaredPrice) {
        toast.error(t("ordersCreate.validation.declaredPriceZeroError"));
        (newErrors.declaredPrice = t("ordersCreate.validation.fillData"));
      }
      if (insurance && !fileInvoice?.name) {
        toast.error(t('ordersCreate.validation.invoiceRequiredError'));
        newErrors.fileInvoice = t('ordersCreate.validation.invoiceRequiredError');
      }

      if (!cityFrom || !countryFrom || !cityTo || !countryTo) {
        toast.error(t("ordersCreate.validation.fillCountryCityError"));
        !cityFrom && (newErrors.cityFrom = t("ordersCreate.validation.fillData"));
        !countryFrom && (newErrors.countryFrom = t("ordersCreate.validation.fillData"));
        !cityTo && (newErrors.cityTo = t("ordersCreate.validation.fillData"));
        !countryTo && (newErrors.countryTo = t("ordersCreate.validation.fillData"));
      }
      if (!category) {
        toast.error(t("ordersCreate.validation.selectCategoryError"));
        !category && (newErrors.category = t("ordersCreate.validation.fillData"));
      }
      if (!type) {
        toast.error(t("ordersCreate.validation.selectTransportTypeError"));
        !type && (newErrors.type = t("ordersCreate.validation.fillData"));
      }
      if (!weight) {
        toast.error(t("ordersCreate.validation.fillWeightVolumeError"));
        !weight && (newErrors.weight = t("ordersCreate.validation.fillData"));
      }
      if (type?.value === "refrigerator" && !temperature) {
        toast.error(t('ordersCreate.validation.fillTemperatureError'));
        newErrors.temperature = t('ordersCreate.validation.fillData');
      }
      if (weight && (weight.toString().length > 8 || parseFloat(weight) < 0)) {
        newErrors.weight = t("ordersCreate.validation.checkWeightError");
        toast.error(t("ordersCreate.validation.invalidWeight"));
      }
      if (volume && (volume.toString().length > 8 || parseFloat(volume) < 0)) {
        newErrors.volume = t("ordersCreate.validation.checkVolumeError");
        toast.error(t("ordersCreate.validation.invalidVolume"));
      }
      if (pallet && (pallet.toString().length > 8 || parseFloat(pallet) < 0)) {
        newErrors.pallet = t("ordersCreate.validation.checkVolumeError");
        toast.error(t("ordersCreate.validation.invalidVolume"));
      }
      if (!isOwnFleetExecutor) {
        toast.error(t('ordersCreate.validation.specifyExecutorError'));
        newErrors.isExecutor = t('ordersCreate.validation.specifyExecutorError');
      }
      if (!price || price <= 0) {
        toast.error(t("ordersCreate.validation.specifyPriceError"));
        newErrors.price = t("ordersCreate.validation.specifyPriceError");
      }
      if (price && parseFloat(price) > 2000000000) {
        toast.error(t('ordersCreate.validation.priceTooLargeError'));
        newErrors.price = t('ordersCreate.validation.priceTooLargeError');
      }
      if (points.length > 0) {
        const pointsErrors = {};
        points.forEach((point, index) => {
          const pointErrors = {};
          if (!point.country) {
            pointErrors.country = t("ordersCreate.validation.points.fillCountry");
          }
          if (!point.city) {
            pointErrors.city = t("ordersCreate.validation.points.fillCity");
          }
          if (!point.address) {
            pointErrors.address = t("ordersCreate.validation.points.fillAddress");
          }
          if (point.shippingDate === null || !point.shippingDate) {
            pointErrors.shippingDate = t("ordersCreate.validation.fillData");
          }
          if (point.shippingHourFrom === 0 || !point.shippingHourFrom) {
            pointErrors.shippingHourFrom = t("ordersCreate.validation.fillData");
          }
          if (point.shippingHourTo === 0 || !point.shippingHourTo) {
            pointErrors.shippingHourTo = t("ordersCreate.validation.fillData");
          }
          if (!point.latLng) {
            pointErrors.latLng = t("ordersCreate.validation.points.fillCoordinates");
          }
          if (!point.recipientName) {
            pointErrors.recipientName = t("ordersCreate.validation.points.fillRecipientName");
          }

          if (Object.keys(pointErrors).length > 0) {
            pointsErrors[`points_${index + 2}`] = pointErrors;
            toast.error(t("ordersCreate.validation.points.incompleteError", { index: index + 2 }));
          }
        });
        if (Object.keys(pointsErrors).length > 0) {
          newErrors.points = pointsErrors;
        }
      }

      setErrors(newErrors);

      return;
    }

    if (isTender && !price) {
      onPriceChange(0);
      createOrder();
    } else if (price && algoPrice) {
      createOrder();
    } else if (price) {
      createOrder();
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Info */}
      <OrdersContentColumn position>
        {(isCopy || isEdit) && (
          <SectionItem
            column={2}
            title={headTitle}
            isShadow
            isCopy
            prefixStart={<CopyIcon fill="#6D7885" />}
            isCunter={false}
          ></SectionItem>
        )}

        <SectionItem column={2} title={t("ordersCreateDesktop.fromSection.title")} counter={1} isShadow>
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t("ordersCreateDesktop.fromSection.countryLabel")}>
              <CustomSelect
                key={"countries-from"}
                labelText={t("ordersCreateDesktop.fromSection.countryShortLabel")}
                placeholder={t("ordersCreateDesktop.fromSection.countryLabel")}
                errorText={!countryFrom && errors?.countryFrom}
                options={countries}
                defaultValue={countryFrom}
                returnObject
                onSubmit={(item) => {
                  onResetPrice();
                  setCountryFrom(item);
                  setCityFrom(null);
                }}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t("ordersCreateDesktop.fromSection.cityLabel")}>
              <CustomSelect
                labelText={t("ordersCreateDesktop.fromSection.cityShortLabel")}
                placeholder={t("ordersCreateDesktop.fromSection.cityLabel")}
                errorText={!cityFrom && errors?.cityFrom}
                options={citiesFrom}
                defaultValue={cityFrom}
                returnObject
                isDisabled={!countryFrom}
                onSubmit={(item) => {
                  onResetPrice();
                  setCityFrom(item);
                  setAddressFrom(null);
                  setAddressIdFrom(null);
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={(searchValue) => {
                  setInitialCityNameFrom(searchValue);
                  setIsOpenAddFrom(true);
                }}
              />
              {isOpenAddFrom && (
                <AddYourCity
                  setCountry={setCountryFrom}
                  setCity={setCityFrom}
                  countries={countries}
                  country={countryFrom}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityFrom}
                  isOpenAdd={isOpenAddFrom}
                  setIsOpenAdd={setIsOpenAddFrom}
                  initialCityName={initialCityNameFrom}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          {/* <OrdersSectionItemInfoColumn>
            <CustomInput
              labelText="Укажите адрес погрузки"
              placeholder="Введите адрес"
              // errorText={errors?.countryFrom}
              inputType="text"
              isBgGray={true}
              defaultValue={""}
            />

          </OrdersSectionItemInfoColumn> */}

          <OrdersSectionItemInfoColumn contentGridColumn={isMobileView ? "1fr" : "1fr 1.3fr"}>
            <OrdersDatePicker
              date={pickUpDate}
              timeStart={pickUpStartTime}
              timeEnd={pickUpEndTime}
              minDate={minPickDate}
              isSender
              isEditable
              setDate={setPickUpDate}
              setTimeStart={setPickUpStartTime}
              setTimeEnd={setPickUpEndTime}
              // detect={saveDraft}
              labelText={t("ordersCreateDesktop.fromSection.dateLabel")}
              labelTimeStart={t("ordersCreateDesktop.fromSection.timeStartLabel")}
              labelTimeEnd={t("ordersCreateDesktop.fromSection.timeEndLabel")}
              placeholderText={t("ordersCreateDesktop.fromSection.datePlaceholder")}
              errorDate={!pickUpDate && errors?.pickUpDate}
              errorTimeStart={!pickUpStartTime && errors?.pickUpStartTime}
              errortimeEnd={!pickUpEndTime && errors?.pickUpEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t("ordersCreateDesktop.fromSection.senderLabel")}
              errorText={!addressFrom && errors?.addressFrom}
              isSender
              isEditable
              forceOpenDropdown={!!addressTo}
              forceOpenDropdownCount={recipientUpdate}
              companyName={senderName}
              countries={countries}
              countrySelected={countryFrom}
              citySelected={cityFrom}
              address={addressFrom}
              onCoordinates={setCoordinatesFrom}
              onRecipientPhone={setSenderPhone}
              onChangeResipient={setSenderName}
              onAddressId={setAddressIdFrom}
              onChangeAddress={(item) => {
                setAddressFrom(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onChangeCountry={(item) => {
                setCountryFrom(item);
                setCityFrom(null);
              }}
              onChangeCity={(city) => {
                setCityFrom(city);
              }}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        {/* <SectionItem column={1} counter={1} isShadow isPSmall isMrAuto>
          <CustomButton
            text="Добавить промежуточную точку"
            prefixStart={<PlusIcon fill="#2857FC" />}
            isUnderline
            isBlueText
            // onClick={}
          />
        </SectionItem> */}

        <AddIntermediatePoint
          points={points}
          setPoints={setPoints}
          countries={countries}
          cities={citiesTo}
          setIsOpenAddTo={setIsOpenAddTo}
          errors={errors?.points}
          user={user}
          pickUpDate={pickUpDate}
        />

        <SectionItem
          column={2}
          title={t("ordersCreateDesktop.toSection.title")}
          counter={2 + points.length}
          isShadow
        >
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t("ordersCreateDesktop.toSection.countryLabel")}>
              <CustomSelect
                labelText={t("ordersCreateDesktop.fromSection.countryShortLabel")} // Reusing 'Country' label
                placeholder={t("ordersCreateDesktop.toSection.countryLabel")}
                options={countries}
                errorText={!countryTo && errors?.countryTo}
                defaultValue={countryTo}
                returnObject
                onSubmit={(item) => {
                  onResetPrice();
                  setCountryTo(item);
                  setCityTo(null);
                  // saveDraft();
                }}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t("ordersCreateDesktop.toSection.cityLabel")}>
              <CustomSelect
                labelText={t("ordersCreateDesktop.fromSection.cityShortLabel")}
                placeholder={t("ordersCreateDesktop.toSection.cityLabel")}
                errorText={!cityTo && errors?.cityTo}
                options={citiesTo}
                defaultValue={cityTo}
                returnObject
                isDisabled={!countryTo}
                onSubmit={(item) => {
                  onResetPrice();
                  setCityTo(item);
                  setAddressTo(null);
                  setCoordinatesTo(null);
                  // saveDraft();
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={(searchValue) => {
                  setInitialCityNameTo(searchValue);
                  setIsOpenAddTo(true);
                }}
              />
              {isOpenAddTo && (
                <AddYourCity
                  setCountry={setCountryTo}
                  setCity={setCityTo}
                  country={countryTo}
                  countries={countries}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityTo}
                  isOpenAdd={isOpenAddTo}
                  setIsOpenAdd={setIsOpenAddTo}
                  initialCityName={initialCityNameTo}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={isMobileView ? "1fr" : "1fr 1.3fr"}>
            <OrdersDatePicker
              date={deliveryDate}
              timeStart={deliveryStartTime}
              timeEnd={deliveryEndTime}
              minDate={points.length > 0 ? points[points.length - 1]?.shippingDate || pickUpDate : pickUpDate}
              isEditable
              setDate={setDeliveryDate}
              setTimeStart={setDeliveryStartTime}
              setTimeEnd={setDeliveryEndTime}
              // detect={saveDraft}
              labelText={t("ordersCreateDesktop.toSection.dateLabel")}
              labelTimeStart={t("ordersCreateDesktop.fromSection.timeStartLabel")} // Reusing 'Time' label
              labelTimeEnd={t("ordersCreateDesktop.fromSection.timeEndLabel")} // Reusing 'To' label
              placeholderText={t("ordersCreateDesktop.fromSection.datePlaceholder")} // Reusing 'Enter date' placeholder
              errorDate={!deliveryDate && errors?.deliveryDate}
              errorTimeStart={!deliveryStartTime && errors?.deliveryStartTime}
              errortimeEnd={!deliveryEndTime && errors?.deliveryEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t("ordersCreateDesktop.toSection.recipientLabel")}
              errorText={!addressTo && errors?.addressTo}
              isEditable
              forceOpenDropdown={!addressFrom}
              forceOpenDropdownCount={recipientUpdate}
              countries={countries}
              address={addressTo}
              countrySelected={countryTo}
              citySelected={cityTo}
              companyName={recipientName}
              phoneNumber={recipientPhone}
              onChangeAddress={(item) => {
                setAddressTo(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onRecipientPhone={setRecipientPhone}
              onCoordinates={setCoordinatesTo}
              onAddressId={setAddressIdTo}
              onChangeResipient={setRecipientName}
              onChangeCountry={(item) => {
                setCountryTo(item);
                setCityTo(null);
                // saveDraft();
              }}
              onChangeCity={(city) => {
                setCityTo(city);
                // saveDraft();
              }}
              // detect={saveDraft}
            />

            {/* <CustomInput
              labelText="Номер телефона"
              placeholder="+7 (777) 777-77-77"
              inputType="text"
              isBgGray={true}
              defaultValue={""}
              isPhone
            /> */}
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <SectionItem
          column={2}
          title={t("ordersCreateDesktop.detailsSection.title")}
          counter={3 + points.length}
          isShadow
        >
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <CustomSelect
              key={types.length}
              labelText={`${t('ordersCreateDesktop.detailsSection.transportsTypeLabel')}*`}
              placeholder={t("ordersCreateDesktop.detailsSection.transportTypePlaceholder")}
              errorText={!type && errors?.type}
              options={types}
              defaultValue={type}
              iconKey="icon"
              onSubmit={(item) => {
                onResetPrice();
                setType(item);
                if (item?.value === "awning") {
                  setTemperature(null);
                }
              }}
              returnObject
            />
            <CustomSelect
              labelText={`${t('ordersCreateDesktop.detailsSection.categoryLabel')}*`}
              placeholder={t("ordersCreateDesktop.detailsSection.categoryPlaceholder")}
              errorText={!category && errors?.category}
              options={categories}
              defaultValue={category}
              onSubmit={(item) => {
                onResetPrice();
                setCategory(item);
              }}
              returnObject
              showAddCategoryButton={true}
              onOptionsUpdate={setCategories}
              onAddCategoryClick={handleAddCategoryClick}
              addCategoryButtonText="Добавить категорию"
            />
            {showCategoryModal && (
              <SimpleCategoryModal
                onClose={() => setShowCategoryModal(false)}
                onCategoryAdded={handleCategoryAdded}
              />
            )}
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr 1fr"}>
            <CustomInputWithUnits
              labelText={`${t("ordersCreateDesktop.detailsSection.weightLabel")}*`}
              isBgGray
              errorText={!weight && errors?.weight}
              inputType="number"
              value={weight}
              onChangeValue={(item) => {
                onResetPrice();
                setWeight(item);
              }}
              onChangeUnit={(unitKey) => {
                setWeightUnit(unitKey);
              }}
              units={WEIGHT_UNITS(t)}
              selectedUnit={weightUnit.key}
            />
            <CustomInput
              labelText={t("ordersCreateDesktop.detailsSection.volumeLabel")}
              isBgGray={true}
              errorText={!volume && errors?.volume}
              prefixEnd={
                <span>
                  {t("ordersCreateDesktop.detailsSection.volumeUnit")}
                  <sup>3</sup>
                </span>
              }
              inputType="number"
              value={volume}
              onChangeValue={(item) => {
                onResetPrice();
                setVolume(item);
                // saveDraft();
              }}
            />
            <CustomInput
              labelText={t("ordersCreateDesktop.detailsSection.pallet")}
              // placeholder={t('ordersCreateDesktop.detailsSection.')}
              isBgGray={true}
              errorText={!pallet && errors?.pallet}
              inputType="number"
              prefixEnd={<PalletIcon />}
              value={pallet}
              onChangeValue={(item) => {
                setPallet(item);
              }}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <CustomInput
              labelText={type?.value === "refrigerator" ? `${t("ordersCreateDesktop.detailsSection.temperatureLabel")}*` : t("ordersCreateDesktop.detailsSection.temperatureLabel")}
              placeholder={t("ordersCreateDesktop.detailsSection.temperaturePlaceholder")}
              inputType="text"
              value={temperature}
              isBgGray={true}
              onChangeValue={handleTemperatureChange}
              isDisabled={type?.value === "awning"}
              errorText={!temperature && errors?.temperature}
            />
            <CustomSelect
              labelText={t("ordersCreateDesktop.detailsSection.loadingTypeLabel")}
              placeholder={isMobileView ? "" : t("ordersCreateDesktop.detailsSection.loadingTypePlaceholder")}
              errorText={!loadingType && errors?.loadingType}
              options={loadingTypes}
              defaultValue={loadingType}
              onSubmit={(item) => {
                setLoadingType(item);
              }}
              returnObject
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <CustomInput
              placeholder={t("comment.placeholder")}
              labelText={t("comment.label")}
              inputType="text"
              isBgGray={true}
              value={details}
              onChangeValue={handleCommentChange}
              // errorText={errors?.}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <CustomUploadFileMultiple
              user={user}
              files={files}
              onUploadFiles={(files) => {
                setFiles(files);
              }}
              serverFiles={serverFiles}
              onDeleteServerFile={onDeleteServerFile}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <SectionItem
          counter={4 + points.length}
          column={2}
          title={t("ordersCreateDesktop.paymentSection.main_title")}
          isShadow
        >
          <OrdersSectionItemPaymentExpeditor
            icon={"/icons/logoY.svg"}
            title={t("ordersCreateDesktop.paymentSection.recommendedPriceTitle")}
            subtitle={""}
            isValidate={isValidateForm}
            price={price}
            algoPrice={algoPrice}
            predictedPrice={predictedPrice}
            priceDiscount={insurancePrice}
            displayInput
            buttonColor="brand"
            defaultCount={copyCount}
            changeInput={setCopyCount}
            updatePrice={updatePrice}
            onPriceChange={onPriceChange}
            isCalculatePrice={isCalculatePrice}
            errorText={!price && errors?.price}
            withInsurance={insurance}
            queryInsurance={queryInsurance}
            declaredPrice={declaredPrice}
            calcInsurance={calcInsurance}
            fileInvoice={fileInvoice}
            setInvoiceFile={setInvoiceFile}
            errorInsurance={!declaredPrice && errors?.declaredPrice}
            errorFileInvoice={!fileInvoice && errors?.fileInvoice}
            // saveDraft={saveDraft}
            user={user}
            errorExecutor={!isOwnFleetExecutor && errors?.isExecutor}
            companyName={user?.companyName}
            currency={currency}
            setCurrency={setCurrency}
            isOwnFleetExecutor={isOwnFleetExecutor}
            setIsOwnFleetExecutor={setIsOwnFleetExecutor}
            isReadOnly={isReadOnly}
          />
        </SectionItem>

        <SectionItem isShadow isPSmall>
          <OrdersSectionItemCreate
            onSubmit={submitFormData}
            onSubmitDraft={saveDraft}
            isLoading={createLoading}
          />
        </SectionItem>
      </OrdersContentColumn>

      <OrdersMap
        isLoadingMap={isLoadingMap}
        routeData={routeData}
        routeStartCity={routeStartCity}
        cityFrom={cityFrom}
        cityTo={cityTo}
        addressIdFrom={addressIdFrom}
        addressIdTo={addressIdTo}
        coordinatesFrom={coordinatesFrom}
        coordinatesTo={coordinatesTo}
        points={points}
        setRouteDistance={setRouteDistance}
        setRouteDuration={setRouteDuration}
      />

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
    </div>
  );
};

export default OrdersCreateExpeditorView;
